import React, { useRef, useEffect, useState, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouteMatch, useHistory } from 'react-router-dom';
import {
  Typography,
  Button,
  // todo uncomment when OUT-141 is complete
  // Paper,
  // Tabs,
  // Tab,
} from '@material-ui/core';
import {
  Print as PrintIcon,
  ChevronLeft as ChevronLeftIcon,
} from '@material-ui/icons';
import ReactToPrint from 'react-to-print';

import {
  getBrandDetails,
  getBrand,
  setBrandPendingIndicator,
} from 'modules/brand';
import { selectUser, selectIsUserAdmin } from 'selectors/user';
import {
  selectBrand,
  selectBrandIsPending,
  selectBrandPinLink,
} from 'selectors/brand';
import Certificate from 'containers/certificate';
import LoadingIndicator from 'components/LoadingIndicator';
import Address from 'components/Address';
import MyBrandAttachments from 'components/myBrandAttachments';
import Image from './components/Image';
import Details from './components/Details';
import Renewal from './components/Renewal';
import Notes from './components/Notes';
import Owners from './components/Owners';
import { useWrapperStyles } from './styles';

const BrandPage = () => {
  const dispatch = useDispatch();
  const brand = useSelector(selectBrand);
  const pending = useSelector(selectBrandIsPending);
  const pinLink = useSelector(selectBrandPinLink);
  const user = useSelector(selectUser);
  const isAdmin = useSelector(selectIsUserAdmin);
  const certRef = useRef(null);
  const classes = useWrapperStyles();
  // todo  uncomment when OUT-141 is complete
  // const [activeTab, setActiveTab] = useState(0);
  const [activeTab] = useState(0);
  const history = useHistory();
  const match = useRouteMatch();
  const { status, premiseAddress, brandOwners, ownedByLoggedInUser } = brand;

  const expired = status === 'EXPIRED';
  const goBack = () => history.goBack();

  // todo uncomment when OUT-141 is complete
  // const handleTabChange = (ev, index) => {
  //   setActiveTab(index);
  // };

  useEffect(() => {
    if (isAdmin) {
      dispatch(getBrandDetails(match.params.id));
    } else {
      dispatch(getBrand(match.params.id));
    }

    return () => {
      dispatch(setBrandPendingIndicator(true));
    };
  }, [match, isAdmin, dispatch]);

  const getContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <Owners
            owners={brand.brandOwners}
            expired={expired}
            user={user}
            brandId={brand.id}
          />
        );
      case 1:
        return (
          <MyBrandAttachments
            title="Brand Iron Images"
            viewOnly={!ownedByLoggedInUser}
          />
        );
      case 2:
        return (
          <MyBrandAttachments
            title="Livestock Photos"
            viewOnly={!ownedByLoggedInUser}
          />
        );
      default:
        return null;
    }
  };

  if (pending) {
    return <LoadingIndicator />;
  }

  return (
    <div className={`container ${classes.root}`}>
      <div className={classes.topActions}>
        <Button size="small" variant="outlined" color="primary" onClick={goBack} data-id="uRl5p">
          <ChevronLeftIcon />Go back
        </Button>
        <ReactToPrint
          trigger={() => (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              data-id="fgj6W"
            >
              Print Certificate&nbsp;<PrintIcon />
            </Button>
          )}
          content={() => certRef.current}
        />
      </div>
      <div className={classes.mainDetails}>
        <div>
          <Image
            positionDescription={brand.positionDescription}
            type={brand.type}
            image={brand.brandImage.imageUrl}
          />
          { expired && <span className={classes.expiredText}>EXPIRED</span>}
        </div>
        <div>
          <div className="row">
            <div>
              <Details brand={brand} ertRef={certRef} isAdmin={isAdmin} />
            </div>
            <div>
              {isAdmin && <Renewal pin={brand.pin} pinLink={pinLink} />}
            </div>
          </div>
          {isAdmin && <Notes />}
        </div>
      </div>
      {!!premiseAddress && (
        <Typography variant="body2" color="textSecondary">
          {`${brandOwners[0].firstName} ${brandOwners[0].lastName}`}<br />
          <Address address={premiseAddress} />
        </Typography>
      )}
      {/* todo add this back when OUT-141 is completed (service api for processing uploaded images) */}
      {/*<div className={classes.tabsContainer}>*/}
      {/*  <Paper elevation={2} square className={classes.tabs}>*/}
      {/*    <Tabs*/}
      {/*      value={activeTab}*/}
      {/*      onChange={handleTabChange}*/}
      {/*      indicatorColor="primary"*/}
      {/*      textColor="primary"*/}
      {/*      aria-label="Profile tabs"*/}
      {/*      centered*/}
      {/*    >*/}
      {/*      <Tab label="Owners" data-id="7nuDh" />*/}
      {/*      <Tab label="Brand Irons" data-id="ELyU7" />*/}
      {/*      <Tab label="Livestock Photos" data-id="UBjjU" />*/}
      {/*    </Tabs>*/}
      {/*  </Paper>*/}
      {/*</div>*/}
      {getContent()}
      <div style={{ display: 'none' }}>
        <div ref={certRef}>
          {isAdmin && <Certificate certificate={brand} />}
        </div>
      </div>
    </div>
  );
};

export default memo(BrandPage);
